/**
 * Stock videos client — hits our server proxy at /api/media/stock/videos
 * so the Pexels API key stays on the server.
 */
import { client } from "../api/client.js";

export async function searchStockVideos(query, perPage = 12) {
    if (!query || !query.trim()) return [];
    const res = await client.searchStockVideos({ q: query, per_page: perPage });
    if (!res?.ok) {
        const err = new Error(res?.error || 'Failed to search stock videos');
        err.code = res?.code;
        throw err;
    }
    return res.videos || [];
}
